import { ApprovalChallengeStatus } from '@wix/ambassador-identity-v1-verification/types';
import '@ungap/with-resolvers';
import { getHttpClient } from './utils';
var OWNER_AUTHENTICATOR_PATH = '_api/verification-web/v1/challenges';
export var APPROVAL_CHALLENGE_STATUS_STOPPED = "STOPPED";
export var checkChallengeStatus = function (id) {
    return getOwnerAppChallenge(id).then(function (status) {
        if (status !==
            ApprovalChallengeStatus.APPROVED) {
            throw status;
        }
        return status;
    });
};
var getOwnerAppChallenge = function (verificationId) {
    return getHttpClient()
        .get("/".concat(OWNER_AUTHENTICATOR_PATH, "/get-challenge?verificationId=").concat(verificationId))
        .then(function (result) { var _a, _b, _c; return (_c = (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.challenge) === null || _b === void 0 ? void 0 : _b.approvalChallenge) === null || _c === void 0 ? void 0 : _c.status; });
};
var NOT_FOUND = -1;
var tenMinute = 60 * 1000;
export var getState = function (item) {
    var state = [[item, Date.now()]];
    var add = function (_item) { state.push([_item, Date.now()]); };
    var remove = function (_item) {
        var index = state.findIndex(function (x) { return x[0] === _item; });
        if (index === NOT_FOUND)
            return;
        state.splice(index, 1);
    };
    return { state: state, add: add, remove: remove };
};
export var multiStateRetry = function (stateItem, cb, retryState) {
    // @ts-ignore
    var _a = Promise.withResolvers(), promise = _a.promise, resolve = _a.resolve, reject = _a.reject;
    var _b = getState(stateItem), state = _b.state, add = _b.add, remove = _b.remove;
    var stop = function () {
        clearInterval(intervalId);
        state.forEach(function (_a) {
            var item = _a[0];
            return remove(item);
        });
        reject(APPROVAL_CHALLENGE_STATUS_STOPPED);
    };
    var intervalId = setInterval(function () {
        Promise.allSettled(state.map(function (_a) {
            var _stateItem = _a[0];
            return cb(_stateItem);
        })).then(function (responses) {
            var rejected = [];
            responses.forEach(function (response, index) {
                var _a;
                var _b = (_a = state[index]) !== null && _a !== void 0 ? _a : [], _stateItem = _b[0], date = _b[1];
                var isStale = date + tenMinute < Date.now();
                var isRejected = (response === null || response === void 0 ? void 0 : response.reason) !== retryState;
                if (response.status === 'rejected' && (isRejected || isStale)) {
                    rejected.push(_stateItem);
                    if (state.length === rejected.length) {
                        clearInterval(intervalId);
                        return reject(response.reason);
                    }
                }
                if (response.status === 'fulfilled') {
                    clearInterval(intervalId);
                    return resolve({ status: response.value, id: _stateItem });
                }
            });
            rejected.forEach(remove);
        });
    }, 2000);
    return {
        promise: promise,
        add: add,
        stop: stop
    };
};
//# sourceMappingURL=multiStateRetry.js.map